<template>
  <div>
    <BasePublisher
      v-for="site in authUser.sites"
      :key="site.siteKey"
      :siteKey="site.siteKey"
      :origin="site.initialDomainWithProtocol"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BasePublisher from './BasePublisher'

export default {
  name: 'SitePublisher',
  components: { BasePublisher },
  computed: {
    ...mapState({
      authUser: (state) => state.UserAuthStore.currentUserAuth
    })
  }
}
</script>
